import { Component } from '@angular/core';

@Component({
	selector: 'document-securite',
	templateUrl: 'document-securite.html',
	styleUrls: ['document-securite.css']
})
export class DocumentSecuriteComponent {
	
	constructor() {}
	
}